var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { forwardRef, } from 'react';
import clsx from 'clsx';
import { Icon } from '../Icon/index.js';
import { BadgeProvider, useBadge } from './BadgeContext.js';
export const Badge = forwardRef((props, ref) => {
    const { as, variant = 'primary', size = 'md', rounded = false, children, leadingIcon, trailingIcon, className } = props, rest = __rest(props, ["as", "variant", "size", "rounded", "children", "leadingIcon", "trailingIcon", "className"]);
    const colorClsx = [
        variant === 'primary' && 'bg-actionPrimary-100 text-actionPrimary-800',
        variant === 'secondary' && 'bg-surface-200 text-basicSurface-800',
        'focus:outline-none focus-visible:ring',
    ];
    const sizeClsx = [
        size === 'sm' && 'px-1.5 py-0.5 text-xs',
        size === 'md' && 'px-2.5 py-0.5 text-xs ',
        size === 'lg' && 'px-3 py-0.5 text-sm',
    ];
    const roundedClsx = {
        rounded: !rounded && size === 'md',
        'rounded-md': !rounded && size === 'lg',
        'rounded-full ': rounded,
    };
    let leadingIconElement;
    if (leadingIcon) {
        const iconClsx = [
            size === 'md' && !!children && '-ml-0.5 mr-1.5',
            size === 'lg' && !!children && '-ml-1 mr-1.5',
            'h-4 w-4',
        ];
        leadingIconElement = (React.createElement(Icon, { className: clsx(iconClsx, colorClsx) }, leadingIcon));
    }
    let trailingIconElement;
    if (trailingIcon) {
        const iconClsx = [
            size === 'md' && !!children && '-mr-0.5 ml-1.5',
            size === 'lg' && !!children && '-mr-1 ml-1.5',
            'h-4 w-4',
        ];
        trailingIconElement = (React.createElement(Icon, { className: clsx(iconClsx, colorClsx) }, trailingIcon));
    }
    const Component = as || 'span';
    return (React.createElement(Component, Object.assign({ ref: ref, className: clsx('inline-flex items-center', 'font-medium ', colorClsx, sizeClsx, roundedClsx, className) }, rest),
        React.createElement(BadgeProvider, { variant: variant, size: size },
            leadingIconElement,
            children,
            trailingIconElement)));
});
const BadgeButton = props => {
    const { children, className } = props, rest = __rest(props, ["children", "className"]);
    const { variant } = useBadge();
    const buttonColorClsx = [
        variant === 'primary' &&
            'text-actionPrimary-400 hover:bg-actionPrimary-200 hover:text-actionPrimary-500 focus:outline-none focus:bg-actionPrimary-500 focus:text-actionPrimary-50',
        variant === 'secondary' &&
            'text-basicSurface-400 hover:bg-basicSurface-200 hover:text-basicSurface-500 focus:outline-none focus:bg-basicSurface-500 focus:text-basicSurface-50',
    ];
    return (React.createElement("button", Object.assign({ type: "button", className: clsx('flex-shrink-0 ml-0.5 h-4 w-4 rounded-full inline-flex items-center justify-center focus:outline-none', buttonColorClsx, className) }, rest), children));
};
Badge.Button = BadgeButton;
//# sourceMappingURL=Badge.js.map